import React from 'react';
import { ExpandableSection, Toggle } from '@amzn/awsui-components-react';
import { Event } from '@/src/types/Event';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { useTranslation } from 'react-i18next';

export interface AITeammateSettingsProps {
  target: Event;
  setAiTeammateEnabled: (enabled: boolean) => void;
  disabled: boolean;
}

export const AITeammateSettings: React.FC<AITeammateSettingsProps> = ({ target, setAiTeammateEnabled, disabled }) => {
  const { t } = useTranslation();

  return (
    <ExpandableSection
      headerText={t(i18nKeys.header.aiTeammate.label)}
      variant="container"
      data-testid="ai-teammate-settings-container"
    >
      <Toggle
        checked={!!target.aiTeammateEnabled}
        disabled={disabled}
        onChange={({ detail }) => setAiTeammateEnabled(detail.checked)}
        data-testid="ai-teammate-toggle"
      >
        {t(i18nKeys.events.eventDetails.labels.aiTeammateToggle.label)}
      </Toggle>
    </ExpandableSection>
  );
};

export default AITeammateSettings;
